import { css, styled } from 'styled-components';

import { ButtonOrLink } from '#/components/ButtonOrLink/ButtonOrLink';
import {
  colors,
  cssBreakpoints,
  fontSizes,
  fontWeights,
  gutterWidth,
  headingSmallText,
  spacing,
  transition,
} from '#/theme/theme';

export const hamburgerMenuIconSlotWidth = 24;

export const HamburgerMenuHolder = styled.div`
  @media all and (min-width: ${cssBreakpoints.mdUp}) {
    display: none;
  }
`;

// Copy of MyAccountMobileDropdownHolder: fixed, full-screen, white
export const HamburgerMenuPanelHolder = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 101;
  overflow-y: scroll;
  background: ${colors.white};
  box-shadow: -2px 0 4px rgb(0 0 0 / 0.1);

  @media all and (min-width: ${cssBreakpoints.mdUp}) {
    display: none;
  }
`;

export const HamburgerMenuPanelHeader = styled.header`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  height: 60px;
  padding: 0 ${gutterWidth / 2}px;
  border-bottom: 1px solid ${colors.selectionGrey};
`;

export const HamburgerMenuPanelBody = styled.div`
  display: flex;
  flex-direction: column;
  padding-bottom: ${spacing[24]};
`;

export const HamburgerMenuSectionHolder = styled.section`
  & + & {
    border-top: 1px solid ${colors.selectionGrey};
  }
`;

export const HamburgerMenuSectionTitle = styled.h2`
  ${headingSmallText};
  color: ${colors.lightContentGrey};
  margin: 0;
  padding: ${spacing[16]} ${gutterWidth / 2}px ${spacing[8]};
`;

export const HamburgerMenuRowsHolder = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;

  &[data-nested] {
    padding-left: ${hamburgerMenuIconSlotWidth + 12}px;
  }
`;

const hamburgerMenuRowCss = css`
  display: flex;
  align-items: center;
  gap: ${spacing[12]};
  width: 100%;
  min-height: 52px;
  padding: 0 ${gutterWidth / 2}px;
  color: ${colors.mediumContentGrey};
  font-size: ${fontSizes[16]};
  font-weight: normal;
  text-align: left;
  text-decoration: none;
  transition: ${transition};
  transition-property: color, background-color;

  &:hover,
  &:focus-visible {
    color: ${colors.brandBlue};
    background-color: ${colors.calloutGrey};
    text-decoration: none;
  }
`;

export const HamburgerMenuLink = styled(ButtonOrLink)`
  ${hamburgerMenuRowCss};
`;

export const HamburgerMenuExpandableButton = styled.button`
  ${hamburgerMenuRowCss};
  border: 0;
  background: none;
  cursor: pointer;
  font-family: inherit;

  &[aria-expanded='true'] {
    color: ${colors.brandBlue};
  }
`;

// Always rendered, even for rows without an icon, so labels line up
export const HamburgerMenuRowIconHolder = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: ${hamburgerMenuIconSlotWidth}px;
  height: ${hamburgerMenuIconSlotWidth}px;

  img {
    width: ${hamburgerMenuIconSlotWidth}px;
    height: ${hamburgerMenuIconSlotWidth}px;
  }
`;

export const HamburgerMenuRowLabel = styled.span`
  flex: 1;
`;

export const HamburgerMenuRowChevronHolder = styled.span`
  display: inline-flex;
  flex-shrink: 0;
  margin-left: auto;
`;

export const HamburgerMenuLogoutLink = styled(HamburgerMenuLink)`
  color: ${colors.alertRed};
  font-weight: ${fontWeights.semiBold};

  &:hover,
  &:focus-visible {
    color: ${colors.alertRedHover};
  }
`;
